
import { uiStore } from "@/store/store";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { openUiPanel } from "@/lib/panels/panels";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: { Icon }
})
export default class EmptyContainer extends Vue {
  @Prop({ default: null })
  id!: number | null;

  get canAddElement() {
    return uiStore.hasFullAccess;
  }

  openAddPanel(e: Event) {
    // Don't open links if inside an `a`
    e.preventDefault();
    e.stopPropagation();

    if (!this.canAddElement) return;

    openUiPanel("add");

    uiStore.activateElement(this.id);
  }
}
